/**
 * Appends opacity to a hex color. Returns the input unchanged when it is not a
 * 6-digit hex (e.g. 3-digit, rgb(...), named colors), so the worst case is an
 * opaque color rather than invalid CSS.
 */
export function hexWithOpacity(hex: string, opacity: string): string {
    const hexWithoutHash = hex.startsWith('#') ? hex.slice(1) : hex;
    if (/^[0-9A-Fa-f]{6}$/.test(hexWithoutHash))
        return `#${hexWithoutHash}${opacity.slice(0, 2).padStart(2, '0')}`;
    return hex;
}
